<div class="dialog-wrapper" [style.min-height]="minHeight">
    <mat-toolbar class="dialog-header" color="primary" *ngIf="!hideHeader">
        <mat-toolbar-row>
            <h2 mat-dialog-title class="dialog-title">{{ title }}</h2>
            <span class="spacer"></span>
            <mat-icon class="close-icon" (click)="onClose()" mat-dialog-close>close</mat-icon>
        </mat-toolbar-row>
    </mat-toolbar>
    <mat-dialog-content class="dialog-content-wrapper">
        <div class="dialog-title-outside-header" *ngIf="hideHeader && title">
            <p class="title-text">{{ title }}</p>
        </div>
        <ng-container #contentContainer></ng-container>
    </mat-dialog-content>
</div>

